import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const UnivapayResult = () => {
  return <CommonResult />;
};

export default UnivapayResult;
